<template>
    <!-- 详情 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="showInputDialog"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :show-confirm="false"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        append-to-body
      >
        <v-form ref="form">
          <v-form-item label="版本ID" prop="">
            <span class="fileUrl">
              {{row.id}}
            </span>
          </v-form-item>
          <v-form-item label="产品" prop="">
            <span class="fileUrl">
              {{row.product_name}}
            </span>
          </v-form-item>
          <v-form-item label="软件版本" prop="">
            <span class="fileUrl">
              {{row.software_version}}
            </span>
          </v-form-item>
          <v-form-item label="硬件版本" prop="">
            <span class="fileUrl">
              {{row.hardware_version}}
            </span>
          </v-form-item>
          <v-form-item  label="固件版本类型">
            <span class="fileUrl">
              {{row.version_typeshow}}
            </span>
          </v-form-item>
          <v-form-item label="版本密码" prop="">
            <span class="fileUrl">
              {{row.version_secret}}
            </span>
          </v-form-item>
          <v-form-item label="语言" prop="">
            <span class="fileUrl">
              {{row.language}}
            </span>
          </v-form-item>
          <v-form-item label="企业名称" prop="">
            <span class="fileUrl">
              {{row.enterprise_name}}
            </span>
          </v-form-item>
          <v-form-item label="是否禁用云服务" prop="">
            <span class="fileUrl">
              {{row.disabled_cloudshow}}
            </span>
          </v-form-item>
          <v-form-item label="系统" prop="system">
            <span class="fileUrl">
              {{row.system}}
            </span>
          </v-form-item>
          <v-form-item label="发布日期" prop="releaseDate">
            <span class="fileUrl">
              {{row.created_at}}
            </span>
          </v-form-item>
          <v-form-item label="固件地址" prop="">
             <span class="fileUrl">{{row.file_url}}</span>
          </v-form-item>
          <v-form-item  label="固件hash码" prop="">
            <span class="fileUrl">
              {{row.file_hash}}
            </span>
          </v-form-item>
          <v-form-item  label="固件大小" prop="">
            <span class="fileUrl">
              {{row.image_size}} byte
            </span>
          </v-form-item>
          <v-form-item  class="description" label="作者描述" prop="">
            <span class="fileUrl">
              {{row.author_description}}
            </span>
          </v-form-item>
          <v-form-item prop="descpSelect"  v-for="(item,index) in row.descp_lang" v-bind:key="index"  class="descp-language">
              <v-form-item  prop="change_log" class="description">
                <template slot="label">
                  <span>更新日志({{item.language}})</span>
                </template>
                 {{row.descp_lang[index].change_log}}
              </v-form-item>

              <v-form-item  prop="new_func" class="description">
                <template slot="label">
                  <span>新功能({{item.language}})</span>
                </template>
                {{row.descp_lang[index].new_func}}
              </v-form-item>

              <v-form-item  prop="optimization" class="description">
                <template slot="label">
                  <span>优化内容({{item.language}})</span>
                </template>
                {{row.descp_lang[index].optimization}}
              </v-form-item>

              <v-form-item  prop="memo" class="description">
                <template slot="label">
                  <span>备注({{item.language}})</span>
                </template>
                {{row.descp_lang[index].memo}}
              </v-form-item>
          </v-form-item>

        </v-form>
      </v-dialog>
    </div>
  </template>

  <script>
  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    row:{
      type:Object,
      default:()=>{}
      },
    },

    data() {
      return {
        cancel: false,

        dialogTitle: "详情",
        languageDataAr:[],
      };
    },
    created(){
      this.languageDataAr = this.row.language.split(',')
    },
    methods: {
      open(){
        this.languageDataAr = this.row.language.split(',')
      },
      handleAfterClose() {
        this.$emit('change')
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
